import { render, staticRenderFns } from "./pagination.component.vue?vue&type=template&id=0db951ec"
import script from "./pagination.component.vue?vue&type=script&lang=js"
export * from "./pagination.component.vue?vue&type=script&lang=js"
import style0 from "./pagination.component.vue?vue&type=style&index=0&id=0db951ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports